
<div class="modal-dialog" style="max-width: 800px; font-family: -apple-system, &quot;Segoe UI&quot;, &quot;Roboto&quot;, &quot;Helvetica Neue&quot;, Arial, sans-serif, &quot;Apple Color Emoji&quot;, &quot;Segoe UI Emoji&quot;, &quot;Segoe UI Symbol&quot;;">
  <div class="modal-content">
    <div class="modal-header border-bottom-0">
      <h5 class="modal-title">Select Smartsheet Workspace</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body" *ngIf="loading">
      <md-spinner-block></md-spinner-block>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <error [error]="error"></error>
      <div class="row" *ngIf="!token">
        <div class="col">
          <button class="btn btn-primary btn-block" (click)="logIn()">Log Into Smartsheet</button>
        </div>
      </div>
      <div class="row" *ngIf="token">
        <div class="col">
          <filtered-list-controls [list]="workspaces" [showSearch]="true" [showLimit]="true"></filtered-list-controls>
          <table class="table table-sm table-responsive pt-3" *ngIf="workspaces.filteredLength">
            <thead>
              <tr>
                <th class="border-top-0 border-bottom-0" style="width: 1%">Selection</th>
                <th class="border-top-0 border-bottom-0 pl-5">Workspace</th>
                <th class="border-top-0 border-bottom-0" style="width: 1%;">
                  <button class="btn btn-link" (click)="clearSelection()">Clear Selection</button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let workspace of workspaces.filtered">
                <td class="text-center">
                  <input type="checkbox" [value]="workspace.id" [(ngModel)]="workspace['selected']">
                </td>
                <td class="pl-5">{{ workspace.name }}</td>
                <td>&nbsp;</td>
              </tr>
              <tr *ngIf="!workspaces.filteredLength">
                <td colspan="2">
                  <p class="text-center empty-table-message">You don't have necessary access to any workspaces.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-outline-primary" type="button" (click)="save()" *ngIf="token">Save</button>
    </div>
  </div>
</div>